import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResponsiveService } from '../shared/responsive/responsive.service';
import { UtilService } from '../shared/services/util.service';
import * as constant from '../shared/constants/constants';
import { StorageService } from '../shared/services/storage.service';
import { EstimatedImpactInterface, OriginalImpactInterface } from '../shared/interfaces/impact_interface';
import { estimated_panel_duration, estimated_panel_duration_order } from '../core/enum';
import { ScenerioService } from '../shared/services/scenerio.service';
import { sortArrayOfObjects } from '../shared/directives/sortArrayOfObjects';
import { ActivatedRoute } from '@angular/router';
import { UrlSecurityService } from '../shared/services/url-security.service';

@Component({
  selector: 'app-estimated-impact',
  templateUrl: './estimated-impact.component.html',
  styleUrls: ['./estimated-impact.component.scss']
})
export class EstimatedImpactComponent implements OnChanges, AfterViewInit {
  /** Scroll content */
  @ViewChild('contentContainer', { static: false }) contentContainer: ElementRef;
  @ViewChild('contentContainer2', { static: false }) contentContainer2: ElementRef;

  /**width variables */
  // estimated panels
  @ViewChild('est_atv_ref', {static: false}) est_atv_ref: ElementRef;
  @ViewChild('est_sales_ref', {static: false}) est_sales_ref: ElementRef;
  @ViewChild('est_transaction_ref', {static: false}) est_transaction_ref: ElementRef;
  @ViewChild('est_wm_ref', {static: false}) est_wm_ref: ElementRef;
  @ViewChild('est_margin_ref', {static: false}) est_margin_ref: ElementRef;
  @ViewChild('est_cogs_ref', {static: false}) est_cogs_ref: ElementRef;
  @ViewChild('est_estimated_units_ref', {static: false}) est_estimated_units_ref: ElementRef;
  
  // original panels
  @ViewChild('original_atv_ref', {static: false}) original_atv_ref: ElementRef;
  @ViewChild('original_sales_ref', {static: false}) original_sales_ref: ElementRef;
  @ViewChild('original_transaction_ref', {static: false}) original_transaction_ref: ElementRef;
  @ViewChild('original_wm_ref', {static: false}) original_wm_ref: ElementRef;
  @ViewChild('original_margin_ref', {static: false}) original_margin_ref: ElementRef;
  @ViewChild('original_cogs_ref', {static: false}) original_cogs_ref: ElementRef;
  @ViewChild('original_estimated_units_ref', {static: false}) original_estimated_units_ref: ElementRef;
  atv_width: any;
  sales_width: any;
  transactions_width: any;
  weekly_margin_width: any;
  margin_width: any;
  cogs_width: any;
  estimated_units_width: any;

  /**impact data flag variable */
  estimated_impact_flag: boolean = false;  // False by default
  original_impact_flag: boolean = false;  // False by default

  /**Input variables to get data from parent component */
  @Input('estimatedImpactDetails') estimated_impact_details: EstimatedImpactInterface;
  @Input('originalImpactDetails') original_impact_details: OriginalImpactInterface;

  /** Impact Arrow Variable */
  arrow_indicator: any = constant.impact_arrow_indicators;
  disable_left_arrow: boolean = true;
  disable_right_arrow: boolean = false;

  /** Configuration Variables */
  configuration: any;
  isPercentage: boolean = true;

  /**duration dropdown variables */
  estimated_weeks_options: any = []
  estimated_weeks: any;
  estimated_duration_dropdown :any = true;

  /**Category Dropdown Variables */
  estimated_category_options: any = []
  estimated_category: any = constant.impact_screen.default_estimated_category_id;
  estimated_category_dropdown :any = true;


  scenario_id:any
  

  /**Event emitter */
  @Output() estimatedDurationCall: EventEmitter<any> = new EventEmitter<any>();
  @Output() estimatedCategoryCall: EventEmitter<any> = new EventEmitter<any>();
  @Input('ptSettings') pt_settings: any;

  constructor(public responsiveService: ResponsiveService, public utilService: UtilService, private storageService: StorageService,private cdr: ChangeDetectorRef, public scenarioSevice : ScenerioService,     public route : ActivatedRoute, public urlService: UrlSecurityService) { 
    this.route.queryParamMap.subscribe((params: any) => {
      this.scenario_id = this.urlService.decryptUsingAES256(params.params.scenario_id);
    })
  }

  ngOnChanges() {
    this.validateImpactData();
    this.getCofigValuesFromSession();
    this.widthCalulator();
  }

  /** Get Service call for Estimated Duration Dropdown */
  getEstimatedDurationDropdown() {
    this.estimated_weeks_options = [];
    this.scenarioSevice.getEstimatedDurationDropdown(this.getEstimatedDurationDropdownPaylod()).subscribe({
      next: (response: any) => {
        this.handleEstimatedDurationDropdownResponse(response)
      }
    })
  }

  /** Get Payload for Estimated Duration Dropdown */
  getEstimatedDurationDropdownPaylod(){
    return {scenario_id: this.urlService.encrypt(this.scenario_id)}
  }
  

  /** Handle Response for Estimated Duration Dropdown */
  handleEstimatedDurationDropdownResponse(response: any) {
    if (response && response?.duration?.length > 0) {
      response.duration.forEach((week_id: any) => {
        this.estimated_weeks_options.push({
          week_id: week_id,
          week_name: estimated_panel_duration[week_id],
          week_order : estimated_panel_duration_order[week_id]
        })
      })
      this.estimated_weeks = constant.impact_screen.default_estimated_week_id;
      this.estimated_weeks_options = sortArrayOfObjects(this.estimated_weeks_options, 'week_order', 'ascending');
      this.estimated_duration_dropdown = true
    }
    else {
      this.estimated_duration_dropdown = false
    }
  }

  /** Get Service call for Estimated Category Dropdown */
  getEstimatedCategoryDropdown() {
    this.estimated_category_options = [];
    this.scenarioSevice.getImpactCategoryDropdown(this.getEstimatedCategoryDropdownPaylod()).subscribe({
      next: (response: any) => {
        this.handleEstimatedCategoryDropdownResponse(response)
      }
    })
  }

  /** Get Payload for Estimated Category Dropdown */
  getEstimatedCategoryDropdownPaylod() {
    return { scenario_id: this.urlService.encrypt(this.scenario_id) }
  }

  /** Handle Response for Estimated Category Dropdown */
  handleEstimatedCategoryDropdownResponse(response: any) {
    if (response) {
      response.forEach((value:any)=>{
        this.estimated_category_options.push(
          {
            category_id: value.sku02,
            category_name: value.skun02 ? value.skun02 : ''
          }
        )

      });
      this.estimated_category_dropdown = true
    }
    else {
      this.estimated_category_dropdown = false
    }
  }

  widthCalulator() {
    setTimeout(() => {
      if(this.est_atv_ref)
      this.atv_width = this.est_atv_ref.nativeElement.offsetWidth;
      if(this.est_sales_ref)
      this.sales_width = this.est_sales_ref.nativeElement.offsetWidth;
      if(this.est_transaction_ref)
      this.transactions_width = this.est_transaction_ref.nativeElement.offsetWidth;
      if(this.est_wm_ref)
      this.weekly_margin_width = this.est_wm_ref.nativeElement.offsetWidth;
      if(this.est_margin_ref)
      this.margin_width = this.est_margin_ref.nativeElement.offsetWidth;
      if(this.est_cogs_ref)
      this.cogs_width = this.est_cogs_ref.nativeElement.offsetWidth;
      if(this.est_estimated_units_ref)
      this.estimated_units_width = this.est_estimated_units_ref.nativeElement.offsetWidth;
      
      if(this.original_atv_ref)
      this.atv_width = Math.max(this.atv_width, this.original_atv_ref.nativeElement.offsetWidth);
      if(this.original_sales_ref)
      this.sales_width = Math.max(this.sales_width, this.original_sales_ref.nativeElement.offsetWidth);
      if(this.original_transaction_ref)
      this.transactions_width = Math.max(this.transactions_width, this.original_transaction_ref.nativeElement.offsetWidth);
      if(this.original_wm_ref)
      this.weekly_margin_width = Math.max(this.weekly_margin_width, this.original_wm_ref.nativeElement.offsetWidth);
      if(this.original_margin_ref)
      this.margin_width = Math.max(this.margin_width, this.original_margin_ref.nativeElement.offsetWidth);
      if(this.original_cogs_ref)
      this.cogs_width = Math.max(this.cogs_width, this.original_cogs_ref.nativeElement.offsetWidth);
      if(this.original_estimated_units_ref)
      this.estimated_units_width = Math.max(this.estimated_units_width, this.original_estimated_units_ref.nativeElement.offsetWidth);
    }, 50);
  }

  ngAfterViewInit() {
    this.widthCalulator();
    this.getEstimatedDurationDropdown();
    this.getEstimatedCategoryDropdown();
    setInterval(() => {
      this.checkArrowsState();
    });
  }

  /** Get Config Values From Session Storage */
  async getCofigValuesFromSession() {
    this.configuration = await this.storageService.get(constant.storage_keys.configuration);
  }

  /**To hide the impact cards if it is empty */
  validateImpactData() {
    if (!this.utilService.isNullOrEmptyOrUndefined(this.estimated_impact_details) && JSON.stringify(this.estimated_impact_details) !== '{}') {
      this.estimated_impact_flag = true;
    }
    if (!this.utilService.isNullOrEmptyOrUndefined(this.original_impact_details) && JSON.stringify(this.original_impact_details) !== '{}') {
      this.original_impact_flag = true;
    }
  }

  /**On Duration dropdown change */
  OnEstimatedWeekChange(event: any){
    this.estimatedDurationCall.emit({estimated_week_id: event.value});
  }

    /**On Category dropdown change */
    OnEstimatedCategoryChange(event: any){
      this.estimatedCategoryCall.emit({estimated_category_id: event.value});
    }



scrollContent(direction: 'left' | 'right') {
  const scrollAmount = direction === 'left' ? -300 : 300;

  if (this.contentContainer && this.contentContainer.nativeElement) {
    const container = this.contentContainer.nativeElement;

    const content_scroll_width = container.scrollWidth;
    let content_scoll_left = container.scrollLeft;
    content_scoll_left += scrollAmount;
    
    if (content_scoll_left >= content_scroll_width) { 
      content_scoll_left = content_scroll_width;
    }

    container.scrollTo({
      left: container.scrollLeft + scrollAmount,
      behavior: 'smooth',
    });

    // to enable/disable the arrow buttons
    container.onscrollend = (event: any) => {
      if (this.contentContainer.nativeElement.scrollLeft == 0) {
        this.disable_left_arrow = true;
        this.disable_right_arrow = false;
      } else if ((this.contentContainer.nativeElement.scrollWidth - this.contentContainer.nativeElement.scrollLeft) <= this.contentContainer.nativeElement.clientWidth) {
        this.disable_left_arrow = false;
        this.disable_right_arrow = true;
      } else {
        this.disable_left_arrow = false;
        this.disable_right_arrow = false;
      }
    };
  }
  
  if (this.contentContainer2 && this.contentContainer2.nativeElement) {
    const container2 = this.contentContainer2.nativeElement;
    container2.scrollTo({
      left: container2.scrollLeft + scrollAmount, 
      behavior: 'smooth',
    });
  }
}

checkArrowsState() {
  if (this.contentContainer && this.contentContainer.nativeElement) {
    const container = this.contentContainer.nativeElement;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    // Disable the left arrow if the user is at the start (left side)
    this.disable_left_arrow = container.scrollLeft <= 0;

    // Disable the right arrow if the user is at the end (right side)
    this.disable_right_arrow = container.scrollLeft >= maxScrollLeft;

    // If there's not enough content to scroll in both directions, disable both arrows
    if (container.scrollWidth <= container.clientWidth) {
      this.disable_left_arrow = true;
      this.disable_right_arrow = true;
    }
  }
}



  /** Price Metric Calculation With Percentage Decimal */
  priceMetricCalculationWithPercentageDecimal(value: any) {
    return this.utilService.priceMetricCalculationWithDecimalService(value, this.configuration.percentage_decimal);
  }

  /** Price Metric Calculation With Two Decimal */
  priceMetricCalculationWithTwoDecimal(value: any) {
    return this.utilService.priceMetricCalculationWithDecimalService(value, this.configuration.decimal_points);
  }

  /** Price Metric Calculation With Percentage Decimal */
  priceMetricCalculationWithThousands(value: any) {
    return this.utilService.priceMetricCalculationWithThousandsService(value, this.configuration.decimal_points);
  }

  /**Tab group change event function */
  valueChangeEvent (event: any) {
    if(event.index == 0)this.isPercentage = false;
    if(event.index == 1)this.isPercentage = true;
    this.widthCalulator();
  }

}
